<template>
  <div class="tab">
    <!-- RN-14: bitácora inmutable. Nadie la edita, ni desde aquí ni desde la
         base: CRM_CX_PLAN_HISTORIAL no admite UPDATE ni DELETE. -->
    <p class="nota">
      Registro completo de los cambios de estado del plan. No se puede editar ni
      borrar.
    </p>

    <ol v-if="plan.historial.length" class="linea">
      <li v-for="(h, i) in plan.historial" :key="i" class="hito">
        <span class="punto"></span>
        <div class="hito-cuerpo">
          <div class="transicion">
            <span v-if="h.de" class="de">{{ h.de }}</span>
            <span v-if="h.de" class="flecha">→</span>
            <span class="a">{{ h.a }}</span>
          </div>
          <div class="meta">{{ h.quien || "Sistema" }} · {{ h.cuando }}</div>
          <p v-if="h.comentario" class="coment">{{ h.comentario }}</p>
        </div>
      </li>
    </ol>

    <p v-else class="vacio">Sin movimientos registrados.</p>
  </div>
</template>

<script>
export default {
  name: "TabHistorial",
  props: { plan: { type: Object, required: true } },
};
</script>

<style scoped>
.tab {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.nota {
  font-size: 12px;
  color: var(--pt-muted);
  margin: 0;
}
.linea {
  list-style: none;
  margin: 0;
  padding: 0 0 0 6px;
  border-left: 2px solid var(--pt-border);
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.hito {
  position: relative;
  padding-left: 18px;
}
.punto {
  position: absolute;
  left: -7px;
  top: 4px;
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #003ca5;
}
.transicion {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.de {
  color: var(--pt-muted);
}
.flecha {
  color: var(--pt-muted);
}
.a {
  font-weight: 600;
}
.meta {
  font-size: 11px;
  color: var(--pt-muted);
  margin-top: 2px;
}
.coment {
  margin: 6px 0 0;
  font-size: 13px;
  color: var(--pt-dim);
  white-space: pre-wrap;
}
.vacio {
  font-size: 14px;
  color: var(--pt-muted);
  text-align: center;
  padding: 24px 0;
  margin: 0;
}
</style>
